import React from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import PasswordChange from "../components/AuthPages/Forgot_Password/PasswordChange";
import { authRoutes, investigatorRoutes } from "./routeConstants";
import PageNotFound from "../components/PageNotFound";
import VisualizationInterface from "../pages/visualization/query_interface/index";
import Investigation from "../pages/investigationAnalysis/Investigation/index";
// import Logs from "../pages/administrator/AuditLogs";
import FilesPreview from "../pages/investigationAnalysis/FilesPreview";
import NewLogsDashboard from "../pages/investigationAnalysis/NewAuditLogs/Dashboard";
import TaskStatusWidgetDashboard from "../pages/investigationAnalysis/NewTaskStatus";
import { useLocation } from "react-router-dom";
import DataValidationList from "../pages/investigationAnalysis/DataValidationList";
import DataValidation from "../pages/investigationAnalysis/DataValidation/index";
import MappingValidationList from "../pages/investigationAnalysis/MappingValidationList";
import MappingValidation from "../pages/investigationAnalysis/MappingValidation/inde";

const AuthRoutes = () => {
  const navigate = useNavigate(); // Use useNavigate instead of withRouter
  return (
    <Routes>
      <Route
        path={`/${authRoutes?.forgotPassword}/:token?`}
        element={<PasswordChange navigate={navigate} />}
      />
      <Route path={`/*`} element={<PageNotFound />} />
    </Routes>
  );
};

// const VisualizationRoutes = () => (
//   <Routes>
//     <Route
//       path={`/${visualizationRoutes?.visualizationInterface}`}
//       element={<VisualizationInterface />}
//     />
//   </Routes>
// );

const InvestigatorRoutes = () => (
  <Routes>
    <Route
      path={`/${investigatorRoutes?.investigationAnalysis}`}
      element={<Investigation />}
    />

    <Route
      path={`/${investigatorRoutes?.logs}`}
      element={<NewLogsDashboard />}
    />

    <Route
      path={`/${investigatorRoutes?.visualizationInterface}`}
      element={<VisualizationInterface />}
    />

    <Route
      path={`/${investigatorRoutes?.taskStatus}`}
      element={<TaskStatusWidgetDashboard />}
    />

    <Route
      path={`/${investigatorRoutes?.filesPreview}`}
      element={<FilesPreview />}
    />

    <Route
      path={`/${investigatorRoutes?.dataValidation}`}
      element={<DataValidationList />}
    />

    <Route
      path={`/${investigatorRoutes?.validateData}`}
      element={<DataValidation />}
    />

    <Route
      path={`/${investigatorRoutes?.mappingValidation}`}
      element={<MappingValidationList />}
    />

    <Route
      path={`/${investigatorRoutes?.validateMapping}`}
      element={<MappingValidation />}
    />

    <Route path={`/*`} element={<PageNotFound />} />
  </Routes>
);

const RoutesChild = () => {
  const location = useLocation();

  if (
    location.pathname === `/${authRoutes.changePassword}` ||
    location.pathname.startsWith(`/${authRoutes.forgotPassword}`)
  ) {
    return <AuthRoutes />;
  }

  switch (localStorage?.userRole) {
    case "investigator":
      return <InvestigatorRoutes />;
    default:
      return <PageNotFound />;
  }
};

export default RoutesChild;
